import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { IExerciseResolution } from '../models/modules';

interface ExerciseResolutionState {
  resolution: IExerciseResolution | null;
  setExerciseResolution: (data: IExerciseResolution) => void;
  resetExerciseResolution: () => void;
}

export const useExerciseResolutionStore = create<ExerciseResolutionState>()(
  persist(
    (set) => ({
      resolution: null,
      setExerciseResolution: (data: IExerciseResolution) => set({ resolution: data }),
      resetExerciseResolution: () => set({
        resolution: null
      })
    }),
    {
      name: 'discipline-exercise-resolution'
    }
  )
);
